import React from 'react';
interface CallToActionProps {
  'data-id'?: string;
}
export function CallToAction({
  'data-id': dataId
}: CallToActionProps) {
  return <div className="w-full relative overflow-hidden" data-id="element-65">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none" data-id="element-66">
        <div className="absolute top-8 left-4 w-24 h-1 bg-gradient-to-r from-benetton-teal to-transparent transform -rotate-12 opacity-60" data-id="element-67"></div>
        <div className="absolute top-12 left-8 w-16 h-1 bg-gradient-to-r from-benetton-magenta to-transparent transform -rotate-6 opacity-40" data-id="element-68"></div>
        <div className="absolute top-16 right-8 w-32 h-1 bg-gradient-to-l from-benetton-lightGreen to-transparent transform rotate-12 opacity-50" data-id="element-69"></div>
        <div className="absolute bottom-12 left-1/4 w-28 h-1 bg-gradient-to-r from-benetton-altBlue to-transparent transform rotate-3 opacity-40" data-id="element-70"></div>
        <div className="absolute bottom-8 right-1/3 w-24 h-1 bg-gradient-to-l from-benetton-red to-transparent transform -rotate-3 opacity-50" data-id="element-71"></div>
      </div>
      
    </div>;
}